<template>
  <div v-title :data-title="$route.name" style="margin-left: 50px">
    <div class="flex flex_left LH_input">
      <el-form :model="formdata" :inline="true">
        <el-form-item label="New Account Name">
          <el-input v-model="formdata.AccountName" show-password></el-input>
        </el-form-item>
        <el-form-item label="Password">
          <el-input v-model="formdata.Password" show-password></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password">
          <el-input v-model="formdata.ConfirmPassword" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="save" type="primary">Create</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      style="max-width: 1200px"
      border
      :header-cell-style="{
        background: '#1484D6',
        color: '#fff',
        padding: ' 5px 0',
      }"
      :data="tabledata"
    >
      <el-table-column
        align="center"
        label="Account ID"
        prop="AccountId"
      ></el-table-column>
      <el-table-column
        align="center"
        label="Account Name"
        prop="AccountName"
      ></el-table-column>
      <el-table-column
        align="center"
        label="Last Login"
        prop="LastLoginTime"
      ></el-table-column>
      <el-table-column align="center" label="Active" prop="EnableUnable">
        <template slot-scope="scope">
          <el-switch
            @change="changeSwitch(scope.row)"
            v-model="scope.row.EnableUnable"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="0"
            :inactive-value="1"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action">
        <template slot-scope="scope">
          <span @click="Modify(scope.row)" class="underline pointer color_red"
            >Change Password</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { get, post } from "../assets/api/api";
import {
  EnableUnableUser,
  LoginUserList,
  UserRegister,
} from "../assets/api/request";

export default {
  data() {
    return {
      formdata: {
        AccountId: 0,
        AccountName: "",
        Password: "",
        ConfirmPassword: "",
      },
      tabledata: [],
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      get(LoginUserList).then((res) => {
        this.tabledata = res.data.data;
      });
    },
    changeSwitch(row) {
      this.$confirm("Do you want to continue?", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          get(
            EnableUnableUser +
              "?AccountId=" +
              row.AccountId +
              "&EnableUnable=" +
              row.EnableUnable
          ).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("Successful.");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.getdata();
        });
    },
    Modify(row) {
      this.formdata = {
        AccountId: row.AccountId,
        AccountName: row.AccountName,
        Password: "",
        ConfirmPassword: "",
      };
    },
    save() {
      if (this.formdata.ConfirmPassword !== this.formdata.Password) {
        this.$message.error("The two passwords entered are inconsistent.");
        return;
      }
      let reg = /^.*(?=.*[A-Z])(?=.*[a-z]){6,18}/;
      if (!reg.test(this.formdata.Password)) {
        this.$message.error(
          `Enter 6-18 characters. Combine uppercase letters, lowercase letters, numbers, and symbols. `
        );
        return;
      }
      this.$confirm("Do you want to continue?", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(() => {
        post(UserRegister, this.formdata).then((res) => {
          // console.log(res);

          if (res.data.code == 200) {
            this.$message.success("modify successful");
            this.getdata();
          }
        });
      });
    },
  },
};
</script>

<style></style>
